var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pay-success"}},[_c('img',{attrs:{"src":require("../assets/images/memberPurchase/success.png"),"alt":""}}),_c('div',[_c('p',[_vm._v("您已成为锦鲤保")]),_c('p',[_vm._v("第"),_c('span',[_vm._v(_vm._s(_vm.vip))]),_vm._v("位会员")])]),_c('button',{on:{"click":_vm.toMy}},[_vm._v("前往个人中心")])])
}
var staticRenderFns = []

export { render, staticRenderFns }